import styled from "styled-components";

const LineDiv = styled.div`
  display: flex;
  margin: 0 auto;
  background-color: #b7d7af;
  width: 23%;
  height: 3px;
  margin-top: -1%;
  margin-bottom: 5%;
`;

export default LineDiv;
